import type { User } from "@/types";

const IMPERSONATION_USER_IDS = new Set([
  "basic-user",
  "firmware-lead",
  "hardware-lead",
  "lab-lead",
  "lab-test-lead",
  "mechanical-lead",
  "project-manager",
]);

const IMPERSONATION_USER_NAMES = new Set([
  "Basic User",
  "Firmware Lead",
  "Hardware Lead",
  "Lab Lead",
  "Lab Test Lead",
  "Mechanical Lead",
  "Project Manager",
]);

export function selectableOwnerNames(users: User[]): string[] {
  return users
    .filter(user => !IMPERSONATION_USER_IDS.has(user.id) && !IMPERSONATION_USER_NAMES.has(user.name))
    .map(user => user.name)
    .sort();
}
